import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
export function ContextDemo() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-gray-900 text-white relative overflow-hidden" data-id="element-474">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-475"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-476">
        <div className="text-center mb-12" data-id="element-477">
          <span className="text-[#0066FF] font-bold tracking-widest uppercase text-sm mb-4 block font-sans" data-id="element-478">
            THE DEMO OFFER
          </span>
          <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] mb-6" data-id="element-479">
            See Your Context Layer In Action
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-480">
            30 minutes. Your use case. Real numbers.
          </p>
        </div>

        <div className="bg-black/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-gray-700 max-w-3xl mx-auto mb-12" data-id="element-481">
          <div className="space-y-10" data-id="element-482">
            <TimeBlock time="Minute 1-10" title="Live Context Capture" desc="Pick your hardest use case. We'll extract your quality standards, compliance requirements, and decision frameworks in real time." data-id="element-483" />
            <TimeBlock time="Minute 11-20" title="Watch Synthia Work" desc="Live before/after comparison using your actual content. Same prompt. Same model. Watch what happens when one has your institutional context." data-id="element-484" />
            <TimeBlock time="Minute 21-30" title="See Your ROI" desc="Custom calculator based on your team size, current revision time, output volume, and compliance costs." data-id="element-485" />
          </div>

          <div className="mt-10 pt-10 border-t border-gray-700 text-[#0066FF] font-medium text-lg" data-id="element-486">
            We'll leave you with a working prototype of your first guardrail.
          </div>
        </div>

        <div className="text-center" data-id="element-487">
          <Link to="/contact" onClick={scrollToTop} className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-white hover:text-[#0066FF] transition-all duration-200" data-id="element-488">
            BOOK A DEMO
            <ArrowRight className="w-5 h-5" data-id="element-489" />
          </Link>
        </div>
      </div>
    </section>;
}
function TimeBlock({
  time,
  title,
  desc
}: {
  time: string;
  title: string;
  desc: string;
}) {
  return <div className="flex gap-8" data-id="element-490">
      <div className="flex-shrink-0 w-40" data-id="element-491">
        <div className="flex items-center gap-2 text-[#0066FF] text-sm font-bold uppercase tracking-wider whitespace-nowrap" data-id="element-492">
          <Clock className="w-4 h-4 flex-shrink-0" data-id="element-493" />
          {time}
        </div>
      </div>
      <div className="flex-1" data-id="element-494">
        <h4 className="text-white font-bold text-xl mb-3 font-['Syne']" data-id="element-495">
          {title}
        </h4>
        <p className="text-gray-400 leading-relaxed" data-id="element-496">{desc}</p>
      </div>
    </div>;
}